module.exports = "<md-button class=\"md-icon-button\" ng-click=\"nav.goBack()\">\r\n    <md-icon class=\"material-icons\">arrow_back</md-icon>\r\n</md-button>";


/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/app/features/navigation/toolbar/toolbarGoBack.html
 ** module id = 295
 ** module chunks = 0
 **/